import { render, staticRenderFns } from "./CampaignLandingPrices.vue?vue&type=template&id=62960208&scoped=true&"
import script from "./CampaignLandingPrices.vue?vue&type=script&lang=js&"
export * from "./CampaignLandingPrices.vue?vue&type=script&lang=js&"
import style0 from "./CampaignLandingPrices.vue?vue&type=style&index=0&id=62960208&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62960208",
  null
  
)

export default component.exports